import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'fontawesome-4.7/css/font-awesome.min.css'

ReactDOM.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
     document.getElementById('root')
);
